import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const OPTIONS = [
  { value: '', label: 'Consultant' },
  { value: 'sarah', label: 'Sarah' },
  { value: 'david', label: 'David' },
];

const menuPaperSx = {
  mt: 0,
  background: 'rgba(6, 18, 40, 0.96)',
  border: '1px solid rgba(50, 175, 252, 0.45)',
  borderTop: 0,
  borderRadius: '0 0 8px 8px',
  boxSizing: 'border-box',
  height: 'auto',
  minHeight: 'unset',
  maxHeight: 'none',
  overflow: 'hidden',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.28)',
};

export default function VoiceProviderSelect({
  value,
  onChange,
  disabled = false,
  placeholder = '',
  buttonSx = {},
  sx = {},
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (next) => {
    onChange(next);
    handleClose();
  };

  const selectedLabel = OPTIONS.find((opt) => opt.value === value)?.label || placeholder;

  return (
    <Box sx={{ zIndex: 50, pointerEvents: 'auto', ...sx }}>
      <Button
        onClick={handleOpen}
        disabled={disabled}
        endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
        sx={{
          fontFamily: 'Dubai, sans-serif',
          fontWeight: 500,
          fontSize: { xs: '14px', sm: '15px' },
          textTransform: 'none',
          color: '#dce7f4',
          backgroundColor: 'transparent',
          border: '1px solid rgba(50, 175, 252, 0.45)',
          borderRadius: open ? '8px 8px 0 0' : '8px',
          minWidth: 44,
          minHeight: 44,
          px: 2,
          py: 0.75,
          '&:hover': {
            backgroundColor: 'rgba(50, 175, 252, 0.08)',
            borderColor: '#32affc',
          },
          '&.Mui-disabled': {
            color: 'rgba(227, 235, 241, 0.45)',
            borderColor: 'rgba(50, 175, 252, 0.2)',
            backgroundColor: 'transparent',
          },
          '& .MuiButton-endIcon': { ml: 0.6 },
          ...buttonSx,
        }}
      >
        {selectedLabel}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            ...menuPaperSx,
            width: anchorEl ? `${anchorEl.getBoundingClientRect().width}px` : undefined,
          },
        }}
        MenuListProps={{
          dense: true,
          sx: {
            py: 0,
            '& .MuiMenuItem-root': {
              borderRadius: 0,
              minHeight: 36,
            },
          },
        }}
      >
        {OPTIONS.map((opt) => (
          <MenuItem
            key={opt.value}
            selected={value === opt.value}
            onClick={() => handleSelect(opt.value)}
            sx={{
              fontFamily: 'Dubai, sans-serif',
              fontSize: '14px',
              color: '#dce7f4',
              borderRadius: 0,
              mx: 0,
              minHeight: 44,
              '&.Mui-selected': {
                color: '#dce7f4',
                backgroundColor: 'rgba(50, 175, 252, 0.08)',
              },
              '&.Mui-selected:hover': {
                backgroundColor: 'rgba(50, 175, 252, 0.12)',
              },
              '&:hover': {
                backgroundColor: 'rgba(50, 175, 252, 0.1)',
              },
            }}
          >
            <Typography component="span" sx={{ fontFamily: 'inherit', fontSize: 'inherit' }}>
              {opt.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
